import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedDoctorRoute = ({ children }) => {
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  if (!doctorData) {
    return <Navigate to="/doctor-login" />;
  }
  if (!doctorData.category_id) {
    return <Navigate to="/select-category" />;
  }
  if (!doctorData.image || !doctorData.designation) {
    return <Navigate to="/doctor-profile-setup/one" />;
  }
  if (!doctorData.about_youself || !doctorData.educational_journey) {
    return <Navigate to="/doctor-profile-setup/two" />;
  }
  if (doctorData.online_consultation == 0 && doctorData.clinic_consultation == 0) {
    return <Navigate to="/doctor-profile-setup/three" />;
  }
  return children;
};

export default ProtectedDoctorRoute;
